module.exports = __webpack_public_path__ + "img/fail-low.7cc44119.png";